module.exports = __webpack_public_path__ + "static/media/other.4d1346f6.jpg";